import(/* webpackMode: "eager" */ "/app/src/app/about/layout.js");
